import { SVGProps } from 'react'

const BoostSalesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9255_41067)">
        <path
          d="M24 12C17.383 12 12 17.383 12 24C12.603 39.898 35.4 39.894 36 24C36 17.383 30.617 12 24 12ZM25 29V30C24.995 31.308 23.005 31.307 23 30V29H22.732C21.665 29 20.669 28.426 20.134 27.501C19.857 27.022 20.021 26.411 20.498 26.135C20.977 25.856 21.589 26.022 21.864 26.499C22.043 26.809 22.375 27 22.731 27H24.999C25.996 27.065 26.442 25.45 25.355 25.24L22.314 24.733C18.812 24.084 19.566 18.98 22.999 19V18C23.005 16.692 24.994 16.693 24.999 18V19H25.267C26.334 19 27.33 19.575 27.865 20.5C28.142 20.978 27.978 21.589 27.501 21.866C27.021 22.143 26.41 21.979 26.135 21.501C25.956 21.192 25.624 21.001 25.268 21.001H23C22.003 20.936 21.558 22.551 22.644 22.761L25.685 23.268C29.187 23.917 28.433 29.02 25 29Z"
          fill="#7181FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_9255_41067">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default BoostSalesIcon
